import { render, staticRenderFns } from "./ModalEndereco.vue?vue&type=template&id=572bfc9d&scoped=true"
import script from "./ModalEndereco.vue?vue&type=script&lang=js"
export * from "./ModalEndereco.vue?vue&type=script&lang=js"
import style0 from "./ModalEndereco.vue?vue&type=style&index=0&id=572bfc9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572bfc9d",
  null
  
)

export default component.exports